import { resolveVideo, getThumbnail } from "@/lib/video";
import { fileUrl } from "@/lib/api";
import { PlayCircle } from "lucide-react";

export default function VideoPlayer({ technique, className = "" }) {
  const v = resolveVideo(technique);
  const poster = technique?.video_type === "upload" && technique?.thumbnail_storage_path
    ? fileUrl(technique.thumbnail_storage_path) : undefined;

  if (v.type === "embed") {
    return (
      <div className={`relative w-full aspect-video rounded-lg overflow-hidden bg-black ${className}`}>
        <iframe data-testid="video-embed" src={v.src} title={technique?.name || "video"}
          className="absolute inset-0 w-full h-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
      </div>
    );
  }
  if (v.type === "file") {
    return (
      <div className={`relative w-full aspect-video rounded-lg overflow-hidden bg-black ${className}`}>
        <video data-testid="video-file" src={v.src} poster={poster} controls preload="metadata" className="absolute inset-0 w-full h-full object-contain" />
      </div>
    );
  }
  return (
    <div className={`relative w-full aspect-video rounded-lg overflow-hidden bg-card border border-border ${className}`}>
      <img src={getThumbnail(technique)} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 text-muted-foreground">
        <PlayCircle className="h-10 w-10" />
        <span className="text-sm">No video added yet</span>
      </div>
    </div>
  );
}
